import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HeaderContainer from '../Header';
import ReviewsDesktop from '../Reviews/ReviewsDesktop';
import { COMPONENT_ID } from '../../constants';
import Container from '../../components/Container';
import Gallery from '../Gallery';
import RatingBadge from '../RatingBadge';
import { getHotelRoulette } from '../../store/selectors/hotel';
import HintFactory from '../../../../components/Hint/HintFactory';
import FortunaJumbotron from '../../components/FortunaJumbotron';

class LayoutDesktop extends React.PureComponent {
  render() {
    const { isRoulette } = this.props;

    return (
      <div className="hotel-desktop">
        <HintFactory events attribute="data-text-hint" />
        <Container white marginBottom={0}>
          <HeaderContainer />
        </Container>
        <Container id={COMPONENT_ID.GALLERY} fullWidth marginBottom={0}>
          {isRoulette ? (
            <FortunaJumbotron />
          ) : (
            <>
              <RatingBadge />
              <Gallery />
            </>
          )}
        </Container>
        {!isRoulette && (
          <>
            <Container id={COMPONENT_ID.REVIEWS}>
              <ReviewsDesktop />
            </Container>
          </>
        )}
      </div>
    );
  }
}

LayoutDesktop.propTypes = {
  isRoulette: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isRoulette: getHotelRoulette(state),
});

export default connect(mapStateToProps)(LayoutDesktop);
